import getProductTitle from './getProductTitle';
import { DEFAULT_TAB_TITLE } from '../consts';
export const getTabTitle = function () {
  let {
    productId,
    toolTitle,
    additionalInformation
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const productTitle = productId && getProductTitle(productId);
  if (productId && !productTitle) {
    console.warn("Translation for ".concat(productId, " is missing - add it on @alloy/exo-skeleton-react"));
  }
  if (productTitle && toolTitle && additionalInformation) {
    return "".concat(additionalInformation, " - ").concat(toolTitle, " - ").concat(productTitle);
  }
  if (productTitle) {
    if (toolTitle) {
      return "".concat(toolTitle, " - ").concat(productTitle);
    }
    if (additionalInformation) {
      return "".concat(additionalInformation, " - ").concat(productTitle);
    }
    return productTitle;
  }
  if (toolTitle) {
    if (additionalInformation) {
      return "".concat(additionalInformation, " - ").concat(toolTitle);
    }
    return "".concat(toolTitle);
  }
  if (additionalInformation) {
    return "".concat(additionalInformation, " - ").concat(DEFAULT_TAB_TITLE);
  }
  return DEFAULT_TAB_TITLE;
};
//# sourceMappingURL=getTabTitle.js.map